import moment from "moment-timezone";

export const sha256Hex = async (value) => {
  try {
    if (!value) return null;
    const encoder = new TextEncoder();
    const data = encoder.encode(value);
    const hashBuffer = await window.crypto.subtle.digest("SHA-256", data);
    return Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  } catch (error) {
    console.log("Auth0 Login - Error hashing guserid", error);
    return null;
  }
};

export const randomXmasImage = Math.floor(Math.random() * (30 - 11 + 1)) + 11;

export const appEnvironment = process.env.REACT_APP_ENVIRONMENT.toLowerCase() || "development";

/******************************************************************
 * ##: Auth0 v2 logout options
 * Returns the canonical logout payload for `@auth0/auth0-react` v2.
 * Reused by NavProfile, app-layout and the Auth0 gate so the
 * `logoutParams.returnTo` shape stays consistent across the app.
 * @returns {{logoutParams: {returnTo: string}}} - Auth0 v2 logout options
 * History:
 * 19-05-2026: Created
 ******************************************************************/
export const getAuth0LogoutOptions = () => ({
  logoutParams: { returnTo: window.location.origin },
});

export const isXMAS = () => {
  const today = moment();
  const xmasStart = moment().month(11).date(1);
  const xmasEnd = moment().month(11).date(30);
  return today.isBetween(xmasStart, xmasEnd);
};

export const getAuthLoadingXmasStyle = () => ({
  backgroundImage: `url("/img/xmas/xmas${randomXmasImage.toString()}.jpg")`,
});

const LOGIN_BACKDROP_LIGHT_WASH =
  "linear-gradient(rgba(248, 250, 252, 0.74), rgba(248, 250, 252, 0.74))";

/** Light hero: horizontal ref - sky blue → lavender → pink/magenta (no coral/orange). */
export const KB_HERO_GRADIENT_LIGHT =
  "linear-gradient(90deg, rgb(80, 167, 249) 0%, rgb(177, 108, 242) 50%, rgb(225, 105, 164) 100%)";

/** Dark: same left-to-right path; darker stops, magenta-pink end (not orange-brown). */
export const KB_HERO_GRADIENT_DARK =
  "linear-gradient(90deg, #1e5799 0%, #5c3d9e 50%, #9a4582 100%)";

const LOGIN_BACKDROP_WASH_DARK_OPACITY = 0.74;
const loginWashDark = `linear-gradient(rgba(15, 23, 42, ${LOGIN_BACKDROP_WASH_DARK_OPACITY}), rgba(15, 23, 42, ${LOGIN_BACKDROP_WASH_DARK_OPACITY}))`;

/**
 * Same CSS backdrop as Auth0LoadingScreen (help-centre hero; no image fetch).
 * @param {string} theme - Redux theme, e.g. "light"
 */
export const getLoginLoadingBackdropStyle = (theme) => {
  if (theme === "light") {
    return {
      backgroundColor: "#f8fafc",
      backgroundImage: [LOGIN_BACKDROP_LIGHT_WASH, KB_HERO_GRADIENT_LIGHT].join(", "),
      backgroundRepeat: "no-repeat, no-repeat",
      backgroundSize: "cover, cover",
    };
  }

  return {
    backgroundColor: "#0f172a",
    backgroundImage: [loginWashDark, KB_HERO_GRADIENT_DARK].join(", "),
    backgroundRepeat: "no-repeat, no-repeat",
    backgroundSize: "cover, cover",
  };
};
